import Swal from "sweetalert2"
import faradayApi from "../../api/faradayApi"


export const createInvestments = async (formValues, succesMsg, errorMsg) => {
    try {
        const { data } = await faradayApi.post('/investments', { data: formValues })

        if (data.ok === true) {
            await Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            return true
        } else {
            await Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        await Swal.fire({
            confirmButtonColor: '#001B60',
            text: error,
            icon: "error",
            iconColor: '#FF7765'
        })
        return false
    }
}

export const converterInvestment = async (formValues, succesMsg, errorMsg) => {

    try {
        const { data } = await faradayApi.put('/investments', formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: error,
            icon: "error",
            iconColor: '#FF7765'
        })
        return false
    }
}

export const deleteInvestment = async (data, succesMsg, errorMsg, cancelButton, confirmButton, deleteConfirm) => {
    const { value } = await Swal.fire({
        text: `${deleteConfirm} ${data.row.startup}`,
        showCancelButton: true,
        confirmButtonColor: '#001B60',
        cancelButtonText: cancelButton,
        confirmButtonText: confirmButton,
        reverseButtons: true
    })

    value && onConfirm(data.row.id, succesMsg, errorMsg, data.row.startup)
}

const onConfirm = async (id, succesMsg, errorMsg, startup) => {

    const { data } = await faradayApi.delete('/investments', { data: { id } });

    data.data !== 0 && !data.error ?
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: `${startup} ${succesMsg}`,
            icon: "success",
        })
        :
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorMsg,
            icon: "error",
        })
}

export const editInvestment = async (formValues, succesMsg, errorMsg) => {
    try {
        const { data } = await faradayApi.put('/investments/editById', formValues)

        if (data.status === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }

    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorMsg,
            icon: "error",
            iconColor: '#FF7765'
        })
        return false
    }
}

export const createOneInvestments = async (formValues, succesMsg, errorMsg) => {
    try {
        const { data } = await faradayApi.post('/investments/createOne', { data: formValues })

        if (data.ok === true) {
            await Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            return true
        } else {
            await Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        await Swal.fire({
            confirmButtonColor: '#001B60',
            text: error,
            icon: "error",
            iconColor: '#FF7765'
        })
        return false
    }
}